export const DEFAULT_FEATURE_FLAGS = {
  STUART: true,
  UBER: false,
};
